import { BookOpen } from "lucide-react";
import { usePageGuidance } from "@/contexts/pageGuidanceContextValue";

export function PageGuidanceToggle() {
  const { pageId, enabled, setEnabled } = usePageGuidance();
  if (!pageId) return null;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      onClick={() => setEnabled(!enabled)}
      className="flex h-9 items-center gap-2 rounded-lg border border-border bg-background px-2.5 text-xs font-medium text-muted-foreground transition hover:text-foreground"
    >
      <BookOpen className="h-3.5 w-3.5" aria-hidden="true" />
      <span className="hidden sm:inline">Explain this page</span>
      <span className="sm:hidden">Explain</span>
      <span
        aria-hidden="true"
        className={`relative h-5 w-9 rounded-full transition-colors ${enabled ? "bg-brand-accent" : "bg-muted"}`}
      >
        <span
          className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform ${enabled ? "translate-x-[18px]" : "translate-x-0.5"}`}
        />
      </span>
    </button>
  );
}
